import { createClientViewClient } from "@midpoint/client-view-sdk";

import { API_BASE_URL } from "../../config/apiBaseUrl.js";

export const clientViewSdk = createClientViewClient({
  baseUrl: API_BASE_URL,
  credentials: "include",
});

export function getApiBaseUrl() {
  return API_BASE_URL;
}

export function mapSdkError(error) {
  return {
    status: error?.status || 0,
    message: error?.message || "Request failed.",
    code: error?.code || "ClientViewSdkError",
    fieldErrors: error?.fieldErrors || [],
  };
}
